module.exports = __webpack_public_path__ + "img/star_brillo.c831e092.svg";